export default __webpack_public_path__ + "assets/CitiBank-d92d5c0fe15a4e9ab5124f0446f200b8.svg";